<!--
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-08-09 13:59:22
 * @LastEditors: lijingjing56
 * @LastEditTime: 2024-12-06 20:58:43
-->
<template>
    <div class="container">
        <banner
            title="京东DAAS"
            describe="京东DAAS整合平台数智产品能力，打造一站式数智服务平台，基于经营增长、用户增长、营销提效、新品创新等四大场景，助力品牌长效增长"
            imgUrl="//img10.360buyimg.com/img/jfs/t1/206063/17/50015/49528/673da4e1F231cfd34/fd0d0c00039e13f9.jpg"
        />
        <contact-us/>
    </div>
</template>
<script>
import banner from '../../components/banner.vue';
import contactUs from './contactUs.vue';
export default {
    name: 'AboutUs',
    components: {
        banner: banner,
        contactUs: contactUs,
    }
}
</script>